exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!vue2-datatable-component/dist/min.css"), "");

// module
exports.push([module.id, "div[name=Datatable] label[name=PageSizeSelect] select.-page-size-select{line-height:10px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6bdc334a!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DataTableComponent.vue
// module id = 906
// module chunks = 2